type QueryPrimitive = string | number | boolean | null | undefined;
type QueryFilterValue = QueryPrimitive | readonly QueryPrimitive[];
export type QueryFilters = Record<string, QueryFilterValue>;

function normalizePrimitive(value: QueryPrimitive): string {
  if (value === null) return 'null';
  if (value === undefined) return '';
  return String(value);
}

function normalizeValue(value: QueryFilterValue): string {
  if (Array.isArray(value)) {
    return value
      .map((item) => normalizePrimitive(item))
      .filter((item) => item.length > 0)
      .join(',');
  }
  return normalizePrimitive(value as QueryPrimitive);
}

/**
 * Stable filter serialization to avoid query-key collisions.
 */
export function serializeFilters(filters?: QueryFilters): string {
  if (!filters) return '';
  const pairs = Object.entries(filters)
    .map(([key, value]) => [key, normalizeValue(value)] as const)
    .filter(([, value]) => value.length > 0)
    .sort(([a], [b]) => a.localeCompare(b));

  return pairs.map(([key, value]) => `${encodeURIComponent(key)}:${encodeURIComponent(value)}`).join('|');
}

/** Omitting filters addresses every cached variant of a resource. */
export function filterKeyParts(filters?: QueryFilters): readonly string[] {
  return filters === undefined ? [] : [serializeFilters(filters)];
}

export function createListKey(namespace: string, filters?: QueryFilters): readonly [string, 'list', string] {
  return [namespace, 'list', serializeFilters(filters)];
}

export function createDetailKey(namespace: string, id: string | number): readonly [string, 'detail', string | number] {
  return [namespace, 'detail', id];
}
